import { ComponentProps } from 'react';
import Profile from '@alltrails/communityapp/profile';
import CustomProvider from 'components/CustomProvider';

type Props = ComponentProps<typeof Profile>;

const ProfileApp = ({ context, fullpath }: Props) => (
  <CustomProvider>
    <Profile context={context} fullpath={fullpath} />
  </CustomProvider>
);

export default ProfileApp;
